import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../../theme/helpers/fontStyle';

export const $StepProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(7)};
  justify-content: center;
  padding: 0 ${spacing(24)};
`;

export const $StepProgressItem = styled.div`
  display: flex;
  flex-direction: column;
  width: ${spacing(24)};
  justify-content: center;
  align-items: center;
`;

export const $StepProgressCircle = styled.div<{ $active?: boolean }>`
  width: ${spacing('xxl')};
  height: ${spacing('xxl')};
  border-radius: 50%;

  background-color: ${({ theme, $active = false }) =>
    $active
      ? theme.newUI.defaultColors.primary
      : theme.newUI.variationColors?.light5};

  color: ${({ theme, $active }) =>
    $active ? theme.colors.white : theme.colors.default};

  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const $StepProgressLabel = styled.div<{ $active?: boolean }>`
  font-weight: ${({ $active = false }) =>
    $active ? fontWeight('semibold') : fontWeight('normal')};
  ${fontStyle('xs')};
  margin-top: ${spacing(2.5)};
  color: ${({ theme, $active = false }) =>
    $active
      ? theme.newUI.variationColors?.dark1
      : theme.newUI.defaultColors.primary};
  width: max-content;
`;

export const $StepProgressSeparator = styled.div<{ $isAfterActive?: boolean }>`
  display: flex;
  flex: 1;
  height: ${spacing('xxl')};
  min-width: 50px;
  align-self: flex-start;
  align-items: center;
  &:after {
    content: '';
    height: ${spacing('xxs')};
    width: 100%;
    background-color: ${({ theme, $isAfterActive = false }) =>
      $isAfterActive
        ? theme.newUI.variationColors?.light5
        : theme.newUI.defaultColors.primary};
    border-radius: 999px;
  }

  &:last-child {
    display: none;
  }
`;
